import type {
  GetListResponseOfWorkflowDefinitionSimpleResponse,
  GetWorkflowDefinitionListRequest,
  WorkflowDefinitionRequest,
  WorkflowDefinitionResponse,
} from 'src/api/ProactApiClient';
import {workflowDefinitionApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const workflowDefinitionApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getWorkflowDefinitionList: builder.query<
      GetListResponseOfWorkflowDefinitionSimpleResponse,
      GetWorkflowDefinitionListRequest
    >({
      queryFn: clientQuery(params => workflowDefinitionApiClient.list(params)),
      providesTags: ['WorkflowDefinitions'],
    }),
    getWorkflowDefinition: builder.query<WorkflowDefinitionResponse, number>({
      queryFn: clientQuery(id => workflowDefinitionApiClient.get(id)),
      providesTags: ['WorkflowDefinitions'],
    }),
    createWorkflowDefinition: builder.mutation<
      WorkflowDefinitionResponse,
      WorkflowDefinitionRequest
    >({
      queryFn: clientQuery(request =>
        workflowDefinitionApiClient.create(request)
      ),
      invalidatesTags: ['WorkflowDefinitions'],
    }),
    updateWorkflowDefinition: builder.mutation<
      WorkflowDefinitionResponse,
      WorkflowDefinitionRequest
    >({
      queryFn: clientQuery(request =>
        workflowDefinitionApiClient.update(request)
      ),
      invalidatesTags: ['WorkflowDefinitions'],
    }),
  }),
});

export const {
  useGetWorkflowDefinitionListQuery,
  useGetWorkflowDefinitionQuery,
  useCreateWorkflowDefinitionMutation,
  useUpdateWorkflowDefinitionMutation,
} = workflowDefinitionApi;
